import DataMap from 'assets/components/dataMap/DataMap';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import Modal from 'assets/components/page/templates/Modal';
import ThemeModalDefault from 'assets/components/page/templates/themes/Theme.Modal.Default';
import TextBox, { textBoxStyles } from 'assets/components/textBox/TextBox';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import BigHr from 'assets/templates/dividers/BigHr';
import Theme from 'assets/themes/Theme.Common';
import { combineStrings } from 'assets/utils/data/String';
import Product from 'models/productManagement/product/Model.Product';

const ClaimEditCorrectionDetails = ({ onClose, claim }: { onClose(): void; claim: Model.IClaim }) => {
  const { lang } = getLocales();

  const { payload: product, isExecuting } = useApi(
    {
      action: Product.find,
      body: {
        id: claim.contract?.productId,
      },
      wait: !claim.contract?.productId,
    },
    [claim.contract?.productId]
  );

  return (
    <Modal
      subcomponents={ThemeModalDefault}
      header={`${claim.number} - ${lang.correctionDetails}`}
      onClose={onClose}
      render={
        <div style={{ display: 'flex', flexDirection: 'column', padding: Theme.Size.XL }}>
          {isExecuting ? (
            <ErrorWrapper children={`${lang.loading}...`} style={{ justifySelf: 'center' }} />
          ) : !claim.claimJobs?.length ? (
            <ErrorWrapper children={lang.noInfo} style={{ justifySelf: 'center' }} />
          ) : (
            <DataMap
              data={claim.claimJobs}
              render={({ data: claimJob }) => {
                const jobName = combineStrings(
                  '-',
                  product?.category?.code,
                  claim?.id?.toString(),
                  `J${claimJob.jobNumber}`
                );

                return (
                  <>
                    <h3 style={{ padding: 0 }}>{jobName}</h3>
                    <TextBox
                      class={textBoxStyles.block.flexBlock}
                      title={`${lang.correctionDetails}:`}
                      subtitle={claimJob.correction ?? 'N/A'}
                    />
                    <BigHr />
                  </>
                );
              }}
            />
          )}
        </div>
      }
    />
  );
};

export default ClaimEditCorrectionDetails;
